import React from "react";
import Image from "next/image";
import styles from "./upsc-mains-test-series-2023.module.css";
import Link from "next/link";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
import check from "../../assets/images/upsc/check.png";
import Learner from "../../assets/images/upsc/Learner.jpg";
import handIcon from "../../assets/images/header/touch-01.png";


const UPSC_Main_Test_Series_2023 = () => {

return (
<>

<div className="container pt-4 pb-4"  style={{background: '#F4F6F8'}}>
  {/* <div className="col-12 text-center pt-4  pb-4 "> */}
     {/* <h3 className={`${styles.acheivertitle} text-center pb-4 mb-0`}>Moksha Detailed test schedule will be available on 24th May 2026.</h3> */}
     {/* <span className="d-block pt-2">  <a className='text-danger' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/Moksha-26-Pamphlet.pdf">Moksha Brochure 2026</a> <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> </span> */}
  {/* </div> */}

  <div className="row pt-3 ">

    <div className="col-md-6 offset-md-2  mt-md-3">
        <a href="https://www.shankariasparliament.com/upsc-toppers-list/2025" target="_blank" className={`${styles.normalbutton1}  d-inline-block text-center align-middle`}>UPSC Toppers Answer Sheet <Image src={handIcon} alt="PDF Icon"width={32} height={32} className={`${styles.blink}`} /></a>
    </div>

    <div className="col-md-4  mt-md-3 pt-2 pt-md-0">
        <a href="https://admissions.shankariasacademy.com/online/" target="_blank" className={`${styles.normalbutton}  d-inline-block text-center align-middle`}>Moksha Login</a>
    </div>
 </div>

</div>

 <div className="container py-5 ">
    <div className={styles.compareTable}>

        {/* Header */}
        <div className={`${styles.tableRow} ${styles.tableHeader}`}>
            <div className={styles.featureCol}>
                <h4>Choose Your Best Fit</h4>
            </div>

            <div className={`${styles.planCol} d-none d-md-block`}>
                <div className={`${styles.planCard}`}>
                    <h5>Starts On</h5>                                                                
                </div>
            </div>

            <div className={`${styles.planCol} d-none d-md-block`}>
                <div className={styles.planCard}>
                    <h5>Detailed Schedule</h5>                                            
                </div>
            </div>

           <div className={`${styles.planCol} d-none d-md-block`}>
               <div className={styles.planCard}>
                    <h5>Admission</h5>    
                </div>
            </div>
        </div>

        {/* Row 1 Freshers */}
        {/* <div className={styles.tableRow}>
            <div className={styles.featureCol}>
                <p className={styles.featureTitle}>Freshers :</p>   
                <span>Suits freshers appearing for Mains 2026 (June 2026 - Aug 2026) (Daily supplement of questions and answers with weekly test)</span>   
            </div>
                                                
            <div className={styles.planCol}>
                <p>12-06-2026</p>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-FRESHERS-2026.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                    >
                    <i className="bi bi-file-earmark-pdf-fill"> </i>
                    View PDF
                </a>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://admissionsv1.shankariasacademy.com/"
                    target="_blank"
                    className={styles.admissionBtn}
                >
                     Pay Now
                </a>
             </div>
        </div> */}

        {/* Row 2 for Veterans */}
        {/* <div className={styles.tableRow}>

            <div className={styles.featureCol}>
                <p className={styles.featureTitle}>Veterans :</p>   
                <span>Suits aspirants with prior Mains experience and appearing for Mains 2026(June 2026 - Aug 2026)(Daily supplement of questions and answers with weekly test)</span>   
            </div>                                  

            <div className={styles.planCol}>
                <p> 12-06-2026</p>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-VETERANS-2026.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                >
                <i className="bi bi-file-earmark-pdf-fill"> </i>
                    View PDF
                </a>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://admissionsv1.shankariasacademy.com/"
                    target="_blank"
                    className={styles.admissionBtn}
                    >
                    Pay Now
                </a>
            </div>
        </div> */}

        {/* Row 3 */}

        <div className={styles.tableRow}>
            <div className={styles.featureCol}>
                <p className={styles.featureTitle}>Mains Only :</p>   
                <span>Suits aspirants preparing for Mains 2027 (July 2026 - Dec 2026)(Daily supplement of questions and answers will be provided in the 2nd phase)</span>   
            </div>
                                                
            <div className={styles.planCol}>
                <p>10-07-2026</p>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-MAINS-ONLY-26.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                >
                <i className="bi bi-file-earmark-pdf-fill"> </i>
                     View PDF
                </a>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://admissionsv1.shankariasacademy.com/"
                    target="_blank"
                    className={styles.admissionBtn}
                >
                    Pay Now
                </a>
            </div>
        </div>

        {/* Row 4 */}
        <div className={styles.tableRow}>
            <div className={styles.featureCol}>
                <p className={styles.featureTitle}>MCP (Mains Cum Prelims) :</p>   
                <span>Suits aspirants seeking integrated preparation for Prelims and Mains 2027 (July 2026 - May 2027) (Daily supplement of questions and answers will be provided in the 2nd phase)</span>   
            </div>

            <div className={styles.planCol}>
               <p>10-07-2026</p>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-MCP-Mains-Cum-Pelims-26.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                >
                <i className="bi bi-file-earmark-pdf-fill"> </i>
                    View PDF
                </a>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://admissionsv1.shankariasacademy.com/"
                    target="_blank"
                    className={styles.admissionBtn}
                >
                    Pay Now
                </a>
            </div>
        </div>


        {/* Row 6 */}
        <div className={styles.tableRow}>
            <div className={styles.featureCol}>
                <p className={styles.featureTitle}>Beginner :</p>   
                <span>Suits aspirants preparing for Mains 2027 (September 2026 - March 2027)</span>   
            </div>

            <div className={styles.planCol}>
                <p>09-10-2026</p>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-BEGINNER-2026.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                >
                <i className="bi bi-file-earmark-pdf-fill"> </i>
                    View PDF
                </a>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://admissionsv1.shankariasacademy.com/"
                    target="_blank"
                    className={styles.admissionBtn}
                 >
                    Pay Now
                </a>
            </div>
        </div>

         <div className={styles.tableRow}>
            <div className={styles.featureCol}>
                <p className={styles.featureTitle}>Short Term :</p>   
                <span>Suits aspirants preparing for Mains 2027 (September 2026 - March 2027)</span>   
            </div>

            <div className={styles.planCol}>
                <p>09-10-2026</p>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-SHORT-TERM-2026.pdf"
                    target="_blank"
                    className={styles.pdfBtn}
                >
                <i className="bi bi-file-earmark-pdf-fill"> </i>
                    View PDF
                </a>
            </div>

            <div className={`${styles.planCol} text-center`}>
                <a
                    href="https://admissionsv1.shankariasacademy.com/"
                    target="_blank"
                    className={styles.admissionBtn}
                 >
                    Pay Now
                </a>
            </div>
        </div>
                                       

    </div>
</div>

<div className="col-md-6 offset-md-1  mt-md-3">
    <a href="/upsc-optional-test-series" target="_blank" className={`${styles.normalbutton1}  d-inline-block text-center align-middle`}>UPSC Optional Test Series - 2026 <Image src={handIcon} alt="PDF Icon"width={32} height={32} className={`${styles.blink}`} /></a>
</div>
            

{/* <div className="container-fluid py-3 py-md-4 pt-xl-5" id="gsttestseries">
        <div style={{background: '', opacity: '1'}}>
            <div className="row">
                <div className="col">
                    <div className="container d-none d-md-block d-lg-block">
                        <div className="row">
                            <div className= {`${styles.tablebg} col-12 border col-md-3 text-center d-none d-md-block`}>
                                <h6 className="pb-3 mt-3"style={{fontWeight:"500"}} >Choose Your Best Fit</h6>
                            </div>

                             <div className={`${styles.tablebg} col-12 border col-md-3 text-center d-none d-md-block`}>
                                <h6 className="pb-3 mt-3"style={{fontWeight:"500"}}>Starts On</h6>
                            </div>

                            <div className={`${styles.tablebg} col-12 border col-md-3 text-center d-none d-md-block`}>
                                <h6 className="pb-3 mt-3"style={{fontWeight:"500"}}>Detailed Schedule</h6>
                            </div>
                            <div className={`${styles.tablebg} col-12 border col-md-3 text-center d-none d-md-block`}>
                                <h6 className="pb-3 mt-3"style={{fontWeight:"500"}} >Admission</h6>
                            </div>
                        </div>


                        <div className="row border ">
                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>Freshers :</span><br/> Suits freshers appearing for Mains 2026 (June 2026 - Aug 2026) <br/> (Daily supplement of questions and answers with weekly test)
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>12-06-2026</span>
                            </div>

                             <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <span className=""><a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-FRESHERS-2026.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</a></span>
                            </div>
                            <div className="col-12 pt-3 col-md-3 text-center d-none d-md-block" >
                                <span> <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton} me-3`} type="submit">Pay Now</button></Link></span>
                            </div>   
                        </div>

                        
                       

                        <div className="row border ">
                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>Veterans :</span> <br/> Suits aspirants with prior Mains experience and appearing for Mains 2026(June 2026 - Aug 2026) <br/> <br/> (Daily supplement of questions and answers with weekly test)
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>12-06-2026</span>
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <span className=""><a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-VETERANS-2026.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</a></span>
                                
                            </div>

                            <div className="col-12 pt-3 col-md-3  text-center d-none d-md-block" >
                                <span> <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton} me-3`} type="submit">Pay Now</button></Link></span>
                            </div>     
                        </div>

                        <div className="row border ">
                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}> Mains Only :</span>  <br/> Suits aspirants preparing for Mains 2027 (July 2026 - Dec 2026) <br/>
                                (Daily supplement of questions and answers will be provided in the 2nd phase)
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>10-07-2026</span>
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <span className=""><a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-MAINS-ONLY-26.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</a></span>
                                
                                
                            </div>

                            <div className="col-12 pt-3 col-md-3  text-center d-none d-md-block" >
                                <span> <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton} me-3`} type="submit">Pay Now</button></Link>
                                </span>
                            </div>     
                        </div> 

                        <div className="row border ">
                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}> MCP (Mains Cum Prelims) :</span>  <br/> Suits aspirants seeking integrated preparation for Prelims and Mains 2027 (July 2026 - May 2027)<br/> (Daily supplement of questions and answers will be provided in the 2nd phase)
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>10-07-2026</span>
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <span className=""><a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-MCP-Mains-Cum-Pelims-26.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</a></span>
                                
                                
                            </div>

                            <div className="col-12 pt-3 col-md-3  text-center d-none d-md-block" >
                                <span> <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton} me-3`} type="submit">Pay Now</button></Link></span>
                            </div>   
                        </div>

                         <div className="row border ">
                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>Beginner :</span><br/> Suits aspirants preparing for Mains 2027 (September 2026 - March 2027)
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <span className=""style={{color:"red"}}>September</span>
                            </div> 

                            <div className={`${styles.bodred} pt-3 col-12 col-md-3  text-center d-none d-md-block`}>
                                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <span className=""><a href="#" target="_blank" className={`${styles.paybill}`}>Update Soon</a></span>
                            </div>
                            <div className="col-12 pt-3 col-md-3  text-center d-none d-md-block" >
                                <span> <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton} me-3`} type="submit">Pay Now</button></Link></span>
                            </div>   
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>  */}

{/*Mobile View table */}

    {/* <div className="container mt-2 mb-5 d-lg-none">
        <div className="col-12 col-xl-12 ">   
            <div className="row">
                <div class=" col-12 col-xl-12 d-block d-md-none">

                    <div className="row border-bottom pt-3 ">  
                        <div class="col-6 pt-3 d-block d-md-none"><b>Choose Your Best Fit</b></div>
                        <div class="col-6 pt-3 col-md-3"> <span className=""style={{color:"red"}}> Freshers  : </span> <br/> Suits freshers appearing for Mains 2026 (June 2026 - Aug 2026) <br/> (Daily supplement of questions and answers with weekly test)</div>               
                        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                        
                        <div class="col-6 pt-3 col-md-3"><Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <b><Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-FRESHERS-2026.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                        
                        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
                        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                    </div> 


                   

                    <div className="row border-bottom pt-3 ">
                        <div class="col-6 pt-3 d-block d-md-none"><b>Choose Your Best Fit</b></div>
                        <div class="col-6 pt-3 col-md-3"> <span className=""style={{color:"red"}}> Veterans :  </span> <br/>  Suits aspirants with prior Mains experience and appearing for Mains 2026(June 2026 - Aug 2026) <br/> <br/> (Daily supplement of questions and answers with weekly test)</div>        
                        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                        
                        <div class="col-6 pt-3 col-md-3"><Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <b><Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-VETERANS-2026.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                        
                        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
                        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                    </div> 

                    <div className="row border-bottom pt-3 "> 
                        <div class="col-6 pt-3 d-block d-md-none"><b>Choose Your Best Fit</b></div> 
                        <div class="col-6 pt-3 col-md-3"> <span className=""style={{color:"red"}}> Mains Only : </span><br/>Suits aspirants preparing for Mains 2027 (July 2026 - Dec 2026) <br/>
                            (Daily supplement of questions and answers will be provided in the 2nd phase)</div>
                        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                       
                        <div class="col-6 pt-3 col-md-3"><Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <b><Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-MAINS-ONLY-26.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                       
                        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
                        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                    </div> 

                    <div className="row border-bottom pt-3 ">      
                        <div class="col-6 pt-3 d-block d-md-none"><b>Choose Your Best Fit</b></div>
                        <div class="col-6 pt-3 col-md-3"> <span className=""style={{color:"red"}}> MCP (Mains Cum Prelims) : </span><br/>Suits aspirants seeking integrated preparation for Prelims and Mains 2027 (July 2026 - May 2027)<br/> (Daily supplement of questions and answers will be provided in the 2nd phase)</div>
                        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                       
                        <div class="col-6 pt-3 col-md-3"><Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <b><Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Mains/UPSC-MCP-Mains-Cum-Pelims-26.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                        
                        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
                        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                    </div>

                     <div className="row border-bottom pt-3 ">  
                        <div class="col-6 pt-3 d-block d-md-none"><b>Choose Your Best Fit</b></div>
                        <div class="col-6 pt-3 col-md-3"> <span className=""style={{color:"red"}}> Beginners  : </span> <br/> Suits aspirants preparing for Mains 2027 (September 2026 - March 2027) </div>               
                        <div class="col-6 pt-3 d-block d-md-none"><b>Schedule</b></div>
                        <div class="col-6 pt-3 col-md-3"><Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/> <b><Link href="#" target="_blank" className={`${styles.paybill}`}>Updated Soon</Link></b></div>
                        
                        
                        <div class="col-6 pt-3  d-block d-md-none"><b>Admission</b></div>
                        <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                    </div> 

                </div>
            </div>
        </div>
    </div>  */}


    {/* <div className="container pt-3">
        <h3 className={`${styles.sectiontitle1} mb-0 py-3 `}>Features of moksha</h3>
    </div>          
    
    <div className="container ">
        <div className="row" id="optionaltest">
            <div className="col-xl-3 col-md-3 col-12 py-xl-3 pt-3">
                <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                    <p className={`${styles.sectiontitle2} p-2`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />FlexiLearn -integrated  online /offline test and discussion</p>
                </div>
            </div>
            <div className="col-xl-3 col-md-3 col-12 py-xl-3 pt-3">
                <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                    <p className={`${styles.sectiontitle2} p-2`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Custom tailored one on one feedback for each test</p>
                </div>
            </div>
            <div className="col-xl-3 col-md-3 col-12 py-xl-3 pt-3">
                <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                    <p className={`${styles.sectiontitle2} p-2`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Structurized completion of syllabus with MAP( Moksha Answer Practice)</p>
                </div>
            </div>
            <div className="col-xl-3 col-md-3 col-12 py-xl-3 pt-3">
                <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                    <p className={`${styles.sectiontitle2} p-2`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Exclusive material for mains (static & current affairs )</p>
                </div>
            </div>
        </div>
    </div> */}

    <div className="container py-4 py-xl-5">

    {/* TITLE */}
    <div className=" mb-2">

        {/* <span className={styles.topTag}>
            Why Choose Moksha
        </span> */}

        <h2 className={`${styles.sectiontitle1} mt-3 py-3`}>
            Features of Moksha
        </h2>

        {/* <p className={styles.subText}>
            Smart preparation ecosystem designed for serious UPSC aspirants
        </p> */}

    </div>



    {/* FEATURES */}
    <div className="row g-4">

        {/* ITEM */}
        <div className="col-12 col-md-6 col-xl-3">

            <div className={styles.featureCard}>
                <div className={styles.iconWrap}>
                    <Image
                        src={check}
                        alt="check"
                        className="img-fluid"
                    />
                </div>

                <h5 className={styles.featureTitle}>
                    FlexiLearn
                </h5>

                <p className={styles.featureText}>
                    Integrated online/offline test and discussion.
                </p>
            </div>
        </div>



        {/* ITEM */}
        <div className="col-12 col-md-6 col-xl-3">

            <div className={styles.featureCard}>

                <div className={styles.iconWrap}>
                    <Image
                        src={check}
                        alt="check"
                        className="img-fluid"
                    />
                </div>

                <h5 className={styles.featureTitle}>
                    Personal Feedback
                </h5>

                <p className={styles.featureText}>
                    Custom-tailored one-on-one feedback for each test
                </p>

            </div>

        </div>



        {/* ITEM */}
        <div className="col-12 col-md-6 col-xl-3">

            <div className={styles.featureCard}>

                <div className={styles.iconWrap}>
                    <Image
                        src={check}
                        alt="check"
                        className="img-fluid"
                    />
                </div>

                <h5 className={styles.featureTitle}>
                    MAP Practice
                </h5>

                <p className={styles.featureText}>
                   Structurized completion of syllabus with MAP( Moksha Answer Practice)
                </p>

            </div>

        </div>



        {/* ITEM */}
        <div className="col-12 col-md-6 col-xl-3">

            <div className={styles.featureCard}>

                <div className={styles.iconWrap}>
                    <Image
                        src={check}
                        alt="check"
                        className="img-fluid"
                    />
                </div>

                <h5 className={styles.featureTitle}>
                    Exclusive Materials
                </h5>

                <p className={styles.featureText}>
                    Special mains material covering static and current
                    affairs content.
                </p>

            </div>

        </div>

    </div>
</div>
   
</>
  )
}
export default UPSC_Main_Test_Series_2023;
